// Charts
import { defineAsyncComponent } from 'vue'

export const BarChartComponent = defineAsyncComponent(() => import('./bar.vue'))
export const DoughnutChartComponent = defineAsyncComponent(() => import('./doughnut.vue'))
export const LineChartComponent = defineAsyncComponent(() => import('./line.vue'))
export const PieChartComponent = defineAsyncComponent(() => import('./pie.vue'))
export const PolarAreaChartComponent = defineAsyncComponent(() => import('./polar-area.vue'))
export const RadarChartComponent = defineAsyncComponent(() => import('./radar.vue'))
export const BubbleChartComponent = defineAsyncComponent(() => import('./bubble.vue'))
export const ScatterChartComponent = defineAsyncComponent(() => import('./scatter.vue'))
export const MixChartComponent = defineAsyncComponent(() => import('./mix-chart.vue'))
export const TableChartComponent = defineAsyncComponent(() => import('./table/table.vue'))
export const SinglestatComponent = defineAsyncComponent(() => import('./singlestat.vue'))